import { gql } from 'graphql-tag';

export const Login = gql`
  mutation login($email: String!, $password: String!, $type: ActorTypeForAuthEnum!) {
    login(input: { email: $email, password: $password, type: $type }) {
      accessToken
    }
  }
`;

export const LOGIN_BY_EMPLOYEE = gql`
  mutation loginByEmployee($type: ActorTypeForAuthEnum!, $email: String!) {
    loginByEmployee(input: { email: $email, type: $type }) {
      accessToken
      returnUrl
    }
  }
`;

export const DEACTIVE_TWO_FACTOR_AUTH = gql`
  mutation {
    deActivateTwoFactorAuth {
      email
    }
  }
`;

export const SET_PASSWORD = gql`
  mutation setPassword(
    $newPassword: String!
    $oldPassword: String
    $email: String!
    $type: ActorTypeEnum!
    $verifyToken: String
    $resetToken: String
  ) {
    setPassword(
      input: {
        oldPassword: $oldPassword
        newPassword: $newPassword
        email: $email
        type: $type
        verifyToken: $verifyToken
        resetToken: $resetToken
      }
    ) {
      email
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($email: String!, $type: ActorTypeEnum!) {
    resetPassword(input: { email: $email, type: $type })
  }
`;

export const UPDATE_PARTNER_ACCOUNT_EMPLOYEE = gql`
  mutation updatePartnerAccountEmployee(
    $first: String
    $last: String
    $id: Float!
    $notificationSubscribe: [NotificationSubscribeInput!]
    $lang: UserLangEnum
    $role: ActorRoleEnum
  ) {
    updatePartnerAccountEmployee(
      input: {
        name: { first: $first, last: $last }
        id: $id
        notificationSubscribe: $notificationSubscribe
        lang: $lang
        role: $role
      }
    ) {
      name {
        first
        last
      }
      role
      email
      notificationSubscribe {
        channel
        trigger
      }
      lang
    }
  }
`;

export const UPDATE_L7_RESOURCE = gql`
  mutation updateL7Resource(
    $partnerClientAccountId: Float!
    $serviceId: Float!
    $serviceEnable: Float
  ) {
    updateL7Resource(
      input: {
        partnerClientAccountId: $partnerClientAccountId
        serviceId: $serviceId
        serviceEnable: $serviceEnable
      }
    ) {
      serviceId
    }
  }
`;

export const UPDATE_PARTNER_CLIENT_ACCOUNT = gql`
  mutation updatePartnerClientAccount($id: Float!, $name: String) {
    updatePartnerClientAccount(input: { name: $name, id: $id }) {
      id
      name
    }
  }
`;

export const UPDATE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE = gql`
  mutation updatePartnerClientAccountEmployee(
    $id: Float!
    $availableLangs: [UserLangEnum!]
    $lang: UserLangEnum
    $restLimit: Float
    $restTtl: Float
    $name: NamePersonInput
  ) {
    updatePartnerClientAccountEmployee(
      input: {
        id: $id
        availableLangs: $availableLangs
        lang: $lang
        restLimit: $restLimit
        restTtl: $restTtl
        name: $name
      }
    ) {
      id
      availableLangs
      lang
      restLimit
      restTtl
      name {
        first
        last
      }
      email
    }
  }
`;

export const UPDATE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE_NAME = gql`
  mutation updatePartnerClientAccountEmployeeName($id: Float!, $first: String, $last: String) {
    updatePartnerClientAccountEmployee(input: { id: $id, name: { first: $first, last: $last } }) {
      id
    }
  }
`;

export const UPDATE_ACCESS_GROUP = gql`
  mutation updateAccessGroup($input: UpdateAccessGroupInput!) {
    updateAccessGroup(input: $input) {
      id
      name
      description
      role
      usersCount
    }
  }
`;

export const UPDATE_ACCOUNT_SETTINGS = gql`
  mutation updateAccountSettings($id: Float!, $l3Limit: Float!, $l7Limit: Float!) {
    updateAccountSettings(
      input: { id: $id, l3: { l3Limit: $l3Limit }, l7: { l7Limit: $l7Limit } }
    ) {
      id
    }
  }
`;

export const UPDATE_ACCOUNT_SETTINGS_L7 = gql`
  mutation updateAccountSettings(
    $id: Float!
    $l7Limit: Float!
    $trialPeriodL7: Date
    $analyzer: Float
    $l7Incidents: Float
    $l7Events: Float
    $visibility: AccountSettignsVisibilityTypeEnum
  ) {
    updateAccountSettings(
      input: {
        id: $id
        l7: {
          l7Limit: $l7Limit
          trialPeriod: $trialPeriodL7
          analyzer: $analyzer
          l7Incidents: $l7Incidents
          l7Events: $l7Events
          visibility: $visibility
        }
      }
    ) {
      id
    }
  }
`;

export const UPDATE_NETWORK_PROTECTION_SETTINGS = gql`
  mutation updateAccountSettings(
    $id: Float!
    $trialPeriod: Date
    $visibility: AccountSettignsVisibilityTypeEnum
  ) {
    updateAccountSettings(
      input: { id: $id, networkProtection: { trialPeriod: $trialPeriod, visibility: $visibility } }
    ) {
      id
    }
  }
`;

export const SET_ACCESS = gql`
  mutation setAccess(
    $partnerClientAccountEmployeeId: Float!
    $l3Delete: [Float!]
    $l3Read: [Float!]
    $l3Update: [Float!]
    $l7Delete: [Float!]
    $l7Read: [Float!]
    $l7Update: [Float!]
    $create: [CreateEmployeeAccessEnum!]
  ) {
    setAccess(
      input: {
        partnerClientAccountEmployeeId: $partnerClientAccountEmployeeId
        l3Delete: $l3Delete
        l3Read: $l3Read
        l3Update: $l3Update
        l7Delete: $l7Delete
        l7Read: $l7Read
        l7Update: $l7Update
        create: $create
      }
    ) {
      id
    }
  }
`;
